import React, { useState, useEffect, useRef, } from "react"
import { BASE_URL } from "../../utils/env"
import Button from "../ui/Button"
import style from "./Playground.module.scss"
import { useDebounce, } from "use-debounce"
import queryString from "query-string"
import cheerio from "cheerio"
import copy from "clipboard-copy"
import cx from "classnames"

export default ({ path, defaultCode = '', copyable, autoFocus, graphOnly }) => {
  const [viewCode, setViewCode, ] = useState(!graphOnly)
  const [shortened, setShortened, ] = useState(false)
  const [ code, setCode ] = useState(defaultCode.replace(/^\n+/, '').replace(/\n+$/, ''))
  const [ debouncedCode ] = useDebounce(code, 500)
  const [ width, setWidth ] = useState(0)
  const [ imageUrl, setImageUrl ] = useState('')
  const [ copied, setCopied ] = useState(false)
  const [ error, setError ] = useState(false)
  const inputRef = useRef()
  const textAreaRef = useRef()

  useEffect(() => {
    const run = async() => {
      ga('send', 'event', 'Graph', 'type')
      const url = `${BASE_URL + path}?${queryString.stringify({ s: debouncedCode })}`
      const response = await fetch(url)

      if (response.ok) {
        const text = await response.text()
        const $ = cheerio.load(text)
        const viewBox = $('svg').first().attr('viewBox')
        setWidth(viewBox ? Number(viewBox.split(' ')[2]) : null)
        setImageUrl(url)
      }

      setError(!response.ok)
    }

    run()
  }, [ debouncedCode ])

  useEffect(() => {
    setCopied(false)
    setShortened(false)
  }, [ code, ])

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto'
      textAreaRef.current.style.height = textAreaRef.current.scrollHeight + 'px'
    }
  }, [ code, viewCode, ])

  useEffect(() => {
    autoFocus && window.innerWidth > 600 && textAreaRef.current.focus()
  }, [])

  const copyUrl = async() => {
    ga('send', 'event', 'Graph', 'copy url')
    const response = await fetch(BASE_URL + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ s: code })
    })

    if (response.ok) {
      const { id } = await response.json()
      setImageUrl(`${BASE_URL}/${id}`)
      setShortened(true)
      setCopied(true)
      copy(`${BASE_URL}/${id}`)
      inputRef.current.select()
    }
  }

  return (
    <div className={style.container}>
      <aside>
        <object type="image/svg+xml" style={{ maxWidth: `${width}px` }} data={imageUrl}/>
        {!viewCode && <div className={style.viewCode} onClick={() => {
          ga('send', 'event', 'Graph', 'view code')
          setViewCode(true)
        }}>View code</div>}
      </aside>
      <article style={{ display: viewCode ? 'block' : 'none' }}>
        <textarea
          ref={textAreaRef}
          value={code}
          className={cx({[style.error]: error})}
          onChange={(event) => setCode(event.target.value)}
          autoComplete="off"
          spellCheck="false"
          data-gramm_editor="false"
        />
        {copyable && <div className={style.toolbar}>
          <input value={imageUrl} onFocus={() => inputRef.current.select()} ref={inputRef} disabled={!shortened}/>
          <Button primary onClick={copyUrl}>
            {copied ? 'Copied!' : 'Copy URL'}
          </Button>
        </div>}
      </article>
    </div>
  )
}
